import styled from '@emotion/styled';
import theme from '../../theme';
import Button from '../Button/Button';

export type ActivationComponentProps = {
  active: boolean,
};

export const Container = styled.div({});

export const ButtonContainer = styled.div({
  marginBottom: '1.875rem',
  [`@media ${theme.breakpoints.above.small}`]: {
    display: 'none',
  },
});

export const TableAndChartContainer = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',

  [`@media ${theme.breakpoints.above.small}`]: {
    marginBottom: '1.875rem',
    '& > div': {
      marginRight: '1rem',
    },
    '& > div:last-child': {
      marginRight: 0,
    },
  },
});

export const MobileShowHideContainer = styled.div((props: ActivationComponentProps) => ({
  [`@media ${theme.breakpoints.below.small}`]: {
    display: props.active ? 'block' : 'none',
    width: '100%',
  },
  [`@media ${theme.breakpoints.above.small}`]: {
    width: '50%',
  },
}));

export const ActivatingButton = styled(Button)({
  marginRight: '0.25rem',
});
